module.exports = __webpack_public_path__ + "img/首页2.adf8d438.jpg";